import { render, staticRenderFns } from "./SelectsType.vue?vue&type=template&id=74af19e0&scoped=true"
import script from "./SelectsType.vue?vue&type=script&lang=js"
export * from "./SelectsType.vue?vue&type=script&lang=js"
import style0 from "./SelectsType.vue?vue&type=style&index=0&id=74af19e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74af19e0",
  null
  
)

export default component.exports